import './App.less';
import { Layout, Row, Col,ConfigProvider } from 'antd';
import React, { Component } from "react";
import cabezal from './static/img/CutedCabezal_Tablilla.jpg'
import 'react-phone-input-2/lib/style.css'
import es_ES from 'antd/lib/locale/es_ES';
import {NavLink} from "react-router-dom";

class Home extends Component {
  render() {
    const { Content } = Layout;
    return (
      <div className="page-container">
        <div className = "content-wrap">
          <ConfigProvider locale={es_ES}>
            <Layout style={{backgroundColor:'white'}}>
        
              <Row justify="center" align="middle" >
                <Col xs={{span:22}} sm={{span:18}} md={{span:16}} lg={{span:15}}>
                  <Row>
                      <Col><img src= {cabezal} style={{width:'100%', height:'100%'}}/></Col>
                  </Row>
                  <Row>
                    <div style={{backgroundColor:'#092462',color:'white', marginTop:'4px', fontSize:'25px', width:'100%'}} >
                    <NavLink style={{color:'white'}} to="/casa"> 
                      <p style={{textAlign:'left', fontWeight:'bold',margin: 'auto',padding:'1%',marginLeft:'8%'}}>
                        PREMIO LITERARIO
                        <span style={{float:'right', fontWeight:'normal'}}>
                            Bases 2024
                        </span>
                      </p>
                      </NavLink>
                    </div>
                  </Row>
                 
              
                  <Row>
                    <div style={{backgroundColor:'#092462',color:'white', marginTop:'4px', fontSize:'25px', width:'100%'}} >
                    <NavLink style={{color:'white'}} to="/musicologia"> 
                      <p style={{textAlign:'left', fontWeight:'bold',margin: 'auto',padding:'1%',marginLeft:'8%'}}>
                      PREMIO DE MUSICOLOGÍA
                          <span style={{float:'right', fontWeight:'normal'}}>
                              Bases 2024
                          </span>
                      </p>
                      </NavLink>
                    </div>
                  </Row>
                  <Row>
                    <div style={{backgroundColor:'#999999',color:'white', marginTop:'4px', fontSize:'25px', width:'100%'}} >
                      <p style={{textAlign:'left', fontWeight:'bold',margin: 'auto',padding:'1%',marginLeft:'8%'}}>
                        PREMIO DE COMPOSICIÓN
                        <span style={{float:'right', fontWeight:'normal'}}>
                        Próxima convocatoria 2024
                        </span>
                      </p>
                    </div>
                  </Row>
                  
                  <Row>
                    <div style={{backgroundColor:'#092462',color:'white', marginTop:'10px', fontSize:'24px', width:'100%'}} >
                    <NavLink style={{color:'white'}} to="/culturasOriginarias"> 
                      <p style={{textAlign:'left', fontWeight:'bold',margin: 'auto',padding:'1%',marginLeft:'8%'}}>
                      COLOQUIO INTERNACIONAL DE ESTUDIOS SOBRE CULTURAS ORIGINARIAS DE AMÉRICA 
                        <span style={{float:'right', fontWeight:'normal'}}>
                            Convocatoria 2024
                        </span>
                      </p>
                      </NavLink>
                    </div>
                  </Row>
                </Col>
              </Row>
            </Layout>
          </ConfigProvider>
        </div>
      </div>
    );
  }
}
export default Home;


